export type SgsLauncherExitHandler = () => void;

const exitHandlers = new Set<SgsLauncherExitHandler>();

function invokeSgsLauncherExitHandlers(): void {
  for (const handler of [...exitHandlers]) {
    try {
      handler();
    } catch {
      /* best-effort while the WebView is tearing down */
    }
  }
}

/**
 * Registers a Hub callback for manufacturing-tablet command-bar **Exit**.
 * The device-management launcher evaluates `window.__sgsOnLauncherExit()` before
 * finishing HubActivity; Android WebView often skips `pagehide` on that path.
 */
export function registerSgsLauncherExitHandler(handler: SgsLauncherExitHandler): () => void {
  if (typeof window === "undefined") {
    return () => undefined;
  }
  exitHandlers.add(handler);
  window.__sgsOnLauncherExit = invokeSgsLauncherExitHandlers;
  return () => {
    exitHandlers.delete(handler);
    if (exitHandlers.size === 0 && window.__sgsOnLauncherExit === invokeSgsLauncherExitHandlers) {
      delete window.__sgsOnLauncherExit;
    }
  };
}
